import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxDropdown } from "@axess/limestone";

export interface IAccountRentalDataInitData {
    rentalParentId: string;
}

export class AccountRentalDataInitData implements IAccountRentalDataInitData {

    constructor(parentId: string) {
        this.rentalParentId = parentId;
    }

    rentalParentId: string;
}

@ModuleName("AccountRentalData")
export class AccountRentalData implements AxInit {
    private rentalParentId: string;
    private _RentalWeightDropDown: AxDropdown = new AxDropdown();
    private _RentalHeightDropDown: AxDropdown = new AxDropdown();
    private _RentalShowSizeDropDown: AxDropdown = new AxDropdown();
    private _RentalSkiLevelDropDown: AxDropdown = new AxDropdown();

    private activeRentalFields: boolean;

    AxInit(init: AccountRentalDataInitData): void {
        this.rentalParentId = init.rentalParentId;

        this.activeRentalFields = $(init.rentalParentId).length !== 0;

        this.initRentalDropdowns();
        this.registerRentalUnitRadios();
    }

    // initRentalDropdowns
    initRentalDropdowns(): void {
        if (!this.activeRentalFields) return;

        this.initWeightDropdown(this.rentalParentId);
        this.initHeightDropdown(this.rentalParentId);
        this.initShoeSizeDropdown(this.rentalParentId);
        this.initSkiLevelDropdown(this.rentalParentId);

        this.updateDropdownValue();
    }

    // updateDropdownValue
    updateDropdownValue() {
        if (!this.activeRentalFields) return;

        const rentalWeight = $("#RentalWeight").val() as string;
        const rentalHeight = $("#RentalHeight").val() as string;
        const rentalShoeSize = $("#RentalShoeSize").val() as string;
        const rentalSkiLevel = $("#RentalSkiLevel").val() as string;

        if ($('.accountsettings__rentalWeight').length > 0) {
            this._RentalWeightDropDown.setValue(rentalWeight != '0' ? rentalWeight : null);
        }

        if ($('.accountsettings__rentalHeight').length > 0) {
            this._RentalHeightDropDown.setValue(rentalHeight != '0' ? rentalHeight : null);
        }

        if ($('.accountsettings__rentalShoeSize').length > 0) {
            this._RentalShowSizeDropDown.setValue(rentalShoeSize != '0' ? rentalShoeSize : null);
        }

        if ($('.accountsettings__rentalSkiLevel').length > 0) {
            this._RentalSkiLevelDropDown.setValue(rentalSkiLevel != '0' ? rentalSkiLevel : '2');
        }
    }

    // resetDropdownSelections
    resetDropdowns() {
        if (!this.activeRentalFields) return;

        $('#RentalWeight').val("");
        $('#RentalHeight').val("");
        $('#RentalShoeSize').val("");
        $('#RentalSkiLevel').val("2");

        this._RentalWeightDropDown.resetSelection();
        this._RentalHeightDropDown.resetSelection();
        this._RentalShowSizeDropDown.resetSelection();
        this._RentalSkiLevelDropDown.resetSelection();
    }

    // initWeightDropdown
    initWeightDropdown(parentId: string): void {
        this._RentalWeightDropDown.init(`${parentId} .accountsettings__rentalWeight`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent: JQuery<HTMLElement>, value: string) => {
                    $('#RentalWeight').val(value);
                }
            }
        );
    }

    // initHeightDropdown
    initHeightDropdown(parentId: string): void {
        this._RentalHeightDropDown.init(`${parentId} .accountsettings__rentalHeight`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent: JQuery<HTMLElement>, value: string) => {
                    $('#RentalHeight').val(value);
                }
            }
        );
    }

    // initShoeSizeDropdown
    initShoeSizeDropdown(parentId: string): void {
        this._RentalShowSizeDropDown.init(`${parentId} .accountsettings__rentalShoeSize`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent: JQuery<HTMLElement>, value: string) => {
                    $('#RentalShoeSize').val(value);
                }
            }
        );
    }

    // initSkiLevelDropdown
    initSkiLevelDropdown(parentId: string): void {
        this._RentalSkiLevelDropDown.init(`${parentId} .accountsettings__rentalSkiLevel`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent: JQuery<HTMLElement>, value: string) => {
                    $('#RentalSkiLevel').val(value);
                }
            }
        );
    }

    // registerRentalUnitRadios
    registerRentalUnitRadios() {
        if (!this.activeRentalFields) return;

        $(this.rentalParentId).on("change", "input[type=radio]", e => {

            let rentalViewModel = {
                Height: $('#RentalHeight').val(),
                Weight: $('#RentalWeight').val(),
                ShoeSize: $('#RentalShoeSize').val(),
                SkiLevel: $('#RentalSkiLevel').val()
            };

            if ($(this.rentalParentId).length > 0) {
                AxessViewer.loadPartialView('/Account/GetAccRentalInfo', {
                    rentalViewModel: rentalViewModel,
                    unit: e.currentTarget.value
                }, resp => {
                    $(this.rentalParentId).html(resp.view);
                    this.initRentalDropdowns();
                }, null);
            }
        });
    }
}